module.exports = {
      id: "calendar-usage",
      viewBox: "0 0 17.552 17.301",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#calendar",
      toString: function () {
        return this.url;
      }
    }